import { TeamsIntegrationSystem } from "@teams/types";
import React from "react";

import { PollyIcon } from "../PollyIcon";

export const IntegrationSystemIcon: React.FC<{ system: TeamsIntegrationSystem }> = ({ system }) => {
  switch (system) {
    case "jira":
      return <PollyIcon inheritColor icon="jira-icon" label="Jira" />;

    case "github":
      return <PollyIcon inheritColor icon="github-icon" label="Github" />;

    case "opsgenie":
      return <PollyIcon inheritColor icon="opsgenie-icon" label="Opsgenie" />;

    case "azure-devops":
      return <PollyIcon inheritColor icon="azure-devops-icon" label="Azure DevOps" />;

    default:
      return <PollyIcon inheritColor icon="q-info-icon" label="Other" />;
  }
};
